var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64937 11.009C8.98406 6.86954 10.1514 4.7998 12 4.7998C13.8486 4.7998 15.0159 6.86953 17.3506 11.009L17.6416 11.5248C19.5817 14.9647 20.5517 16.6846 19.675 17.9422C18.7983 19.1998 16.6292 19.1998 12.2909 19.1998H11.7091C7.37085 19.1998 5.20174 19.1998 4.32501 17.9422C3.44827 16.6846 4.41833 14.9647 6.35844 11.5248L6.64937 11.009Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.7998V12.7998",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9992,
    cy: 15.2004,
    r: 0.8,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.d53a39f2f1eb4de50ae7f5b3b30f2ca6.svg";
export { ForwardRef as ReactComponent };